import PropTypes from "prop-types";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";

const H5 = ({ children }) => (
    <TextStyles
        as="h5"
        textStyles={["Myriad Pro/18-100-semibold-semiextended", null, null, null, null, "Myriad Pro/20-100-semibold"]}
    >
        {children}
    </TextStyles>
);

H5.propTypes = {
    children: PropTypes.node.isRequired,
};

export default H5;
